import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// ⚠️ REPLACE with your own Firebase project config
const firebaseConfig = {
    apiKey: "AIzaSyDkk3NK5x5zVCRJiyj9S7qqc83rDt3Y6sk",
    authDomain: "a11y-scanner-c052f.firebaseapp.com",
    projectId: "a11y-scanner-c052f",
    storageBucket: "a11y-scanner-c052f.firebasestorage.app",
    messagingSenderId: "32340275186",
    appId: "1:32340275186:web:60e95dc5c7b76a4029056b",
    measurementId: "G-HYW2FKV2W8"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export default app;
